import MatchEvent from 'interfaces/matchEvent';
import Period, { PeriodSorting } from '../../../enums/period';
import { secondaryEvents, tertiaryEvents } from '../../../enums/matchEventType';

export default function (matchEvents: MatchEvent[]): MatchEvent[] {
  const filteredMatchEvents = matchEvents.filter((matchEvent) => {
    return (
      !secondaryEvents.includes(matchEvent.matchEventTypeId) && !tertiaryEvents.includes(matchEvent.matchEventTypeId)
    );
  });

  return sortMatchEvents(filteredMatchEvents).reverse();
}

function sortMatchEvents(matchEvents: MatchEvent[]): MatchEvent[] {
  return matchEvents.sort((a: any, b: any): any => {
    if (a.periodId === b.periodId) {
      if (a.time === b.time) {
        if (a.overtime === b.overtime) {
          if ((a.seconds && b.seconds && a.seconds === b.seconds) || (!a.seconds && !b.seconds)) {
            return a.sorting > b.sorting ? 1 : -1;
          }
          return a.seconds > b.seconds ? 1 : -1;
        }
        return a.overtime > b.overtime ? 1 : -1;
      }
      return a.time > b.time ? 1 : -1;
    }
    const aPeriodSorting = getPeriodSortingFromMatchEvent(a);
    const bPeriodSorting = getPeriodSortingFromMatchEvent(b);
    return aPeriodSorting > bPeriodSorting ? 1 : -1;
  });
}

function getPeriodSortingFromMatchEvent(matchEvent: MatchEvent): PeriodSorting {
  const enumKey = Period[matchEvent.periodId];
  return PeriodSorting[enumKey];
}
